import { HTTPAuth } from '@/services/http-common';
import { createQueryString, wrapAxiosRequest } from '@/utils';
import { IApiResponse, QueryRecord } from '@/types';

export class ApiAuth<T> {
  public static get<T>(endpoint: string, query?: QueryRecord): Promise<IApiResponse<T>> {
    const queryString = query ? `?${createQueryString(query)}` : '';
    return wrapAxiosRequest(HTTPAuth.get<T>(`${endpoint}${queryString}`));
  }

  public static post<T>(endpoint: string, payload?: QueryRecord): Promise<IApiResponse<T>> {
    return wrapAxiosRequest(HTTPAuth.post<T>(endpoint, payload));
  }

  public static patch<T>(endpoint: string, payload?: QueryRecord): Promise<IApiResponse<T>> {
    return wrapAxiosRequest(HTTPAuth.patch<T>(endpoint, payload));
  }

  public static put<T>(endpoint: string, payload?: QueryRecord): Promise<IApiResponse<T>> {
    return wrapAxiosRequest(HTTPAuth.put<T>(endpoint, payload));
  }
}
